import { useTranslation } from "~/hooks/useTranslation";
import { ENameSpace } from "~/i18n/@types/types";
import {
  ConnectingButton,
  DesktopJoinButton,
  GreenButton,
  ReloadButton,
} from "~/modules/Router/Auth/components/Buttons";
import { WhiteButton } from "~/modules/Router/Auth/components/Buttons/WhiteButton";
import { useCommunityJoin } from "~/modules/Router/Auth/hooks/useCommunityJoin";

type Props = {
  className?: string;
  hiddenExploreButton?: boolean;
} & Pick<
  ReturnType<typeof useCommunityJoin>,
  | "status"
  | "needConnectWallet"
  | "handleClickExplore"
  | "handleClickConnectWalletButton"
  | "handleClickVerifyButton"
>;

export const DesktopCommunityJoinButton = ({
  className,
  hiddenExploreButton,
  status,
  needConnectWallet,
  handleClickExplore,
  handleClickConnectWalletButton,
  handleClickVerifyButton,
}: Props) => {
  const { t } = useTranslation([ENameSpace.Common] as const);

  let content;
  if (status === "connected") {
    content = (
      <>
        {!hiddenExploreButton && (
          <WhiteButton onClick={handleClickExplore} className={`w-[8.75rem]`}>
            {t(`${ENameSpace.Common}:communityJoin.explore`)}
          </WhiteButton>
        )}
        {needConnectWallet ? (
          <GreenButton
            onClick={handleClickConnectWalletButton}
            className="w-[8.75rem]"
          >
            {t(`${ENameSpace.Common}:communityJoin.connectWallet`)}
          </GreenButton>
        ) : (
          <DesktopJoinButton onClick={handleClickVerifyButton} />
        )}
      </>
    );
  } else if (status === "notSatisfied") {
    content = <ReloadButton onClick={handleClickVerifyButton} />;
  } else {
    content = <ConnectingButton />;
  }

  return <div className={className}>{content}</div>;
};
